/* eslint-disable class-methods-use-this,@typescript-eslint/no-unused-vars */

import * as Yup from 'yup';
import { IFormDefinition } from '../formDefinitionInterface';
import { ISignUpPhoneNumberConfirmationForm } from './types';

export class SignUpPhoneNumberConfirmationFormDefinition implements IFormDefinition {
  public validationSchema: any = Yup.object().shape({
    token: Yup.string()
      .required('Please enter a confirmation code')
      .matches(/^\d+$/, 'Confirmation code will only consist of numbers')
      .min(6, 'Confirmation code must be at least 6 characters'),
  });

  public initialValues(dataOverride?: any): ISignUpPhoneNumberConfirmationForm {
    const values = {
      token: '',
    };
    return values;
  }

  public HUMANIZATION_MAP = {
    token: 'Confirmation token',
  };
}
